/* eslint semi: "off" */
/* eslint react/jsx-filename-extension: "off" */
/* eslint react/prop-types: "off" */
/* eslint no-console: "off" */
/* eslint jsx-a11y/click-events-have-key-events: "off" */
/* eslint jsx-a11y/no-noninteractive-element-interactions: "off" */
/* eslint jsx-a11y/anchor-has-content: "off" */
/* eslint react/no-multi-comp: "off" */
/* eslint no-underscore-dangle: "off" */
import initialState from './initialState';
// import * as types from '../constants/actionTypes';

export default function (state = initialState.context, action) {
  // const newState;
  let sessionId
  let newState
  switch (action.type) {
    case 'SET_SESSION_ID':
      sessionId = action.payload
      newState = Object.assign({}, state, { sessionId })
      // console.log('contextReducer', sessionId, newState);
      return newState
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/contextReducer.js